import { useEffect, useMemo, useState } from 'react';

export const useRotation = (innerBody: HTMLDivElement | null, isOpen: boolean) => {
	const [desktopWidth, setDesktopWidth] = useState(720);

	const formHeight = useMemo(() => {
		if (typeof window !== 'undefined') {
			if (!isOpen) {
				return window.innerHeight;
			}
			return innerBody?.clientHeight ?? window.innerHeight;
		}
		return 0;
	}, [isOpen, innerBody]);

	const handleOrientationChange = (e) => {
		const target = e.target as ScreenOrientation;

		setDesktopWidth(
			target?.type === 'landscape-primary' || target?.type === 'landscape-secondary'
				? window.innerHeight >= formHeight
					? 360
					: 720
				: 360,
		);
	};

	useEffect(() => {
		screen.orientation.addEventListener('change', handleOrientationChange);

		return function () {
			screen.orientation.removeEventListener('change', handleOrientationChange);
		};

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		const isLandscape =
			screen.orientation.type === 'landscape-primary' || screen.orientation.type === 'landscape-secondary';
		let x = 360;
		if (isLandscape && window.innerHeight >= formHeight && window.innerWidth >= 720 && formHeight > 768) {
			x = 720;
		}
		setDesktopWidth(x);
	}, [formHeight]);

	return {
		desktopWidth,
	};
};
